import React, { Component } from "react";
import {
  initMap,
  setMarkers,
  setSelectedMarker,
  clearMarkers,
  setMode,
  setCenter
} from "../../../lib/here";

// website: "https://creatyonarylab.com",
// contactEmail: "admin@findclasses.co.nz",
// contactPerson: "Marina Goldburt",
// locations: [
//   { address: "41 Wood Bay road", name: "Home", id: "1" },
//   { address: "Queen street", name: "Work", id: "2" }
// ]

export default class Geocoding extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let markers = this.props.markers;
    if (this.props.selectedMarkers && markers) {
      setSelectedMarker(this.props.selectedMarkers);
    }
    if (this.props.center) {
      setCenter(this.props.center);
    }
    if (markers) {
      setMarkers(markers);
    }
  }
  componentWillReceiveProps(props) {
    const { fullSelected } = props;
    setMode(!!fullSelected);
    let markers = props.markers;
    if (props.selectedMarkers && markers && !fullSelected) {
      setSelectedMarker(props.selectedMarkers);
    }
    if (fullSelected) {
      setSelectedMarker(fullSelected, true);
    }
    if (markers) {
      setMarkers(markers, fullSelected);
    }
  }
  componentWillUnmount() {
    clearMarkers();
  }
  render() {
    return <React.Fragment />;
  }
}
